import React from "react";
import PropTypes from "prop-types";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

/* TODO
 *   list all icons
 *   icon classes
 * */

export const AESVG = ({
  path,
  variant,
  size,
  className,
  prefix = "/icons",
  children,
  ...props
}) => {
  let classes = [className, "svg-icon", "menu-icon"];
  if (variant) classes.push(`svg-icon-${variant}`);
  if (size) classes.push(`svg-icon-${size}`);

  return (
    <span className={classes.join(" ")} {...props}>
      <SVG
        src={toAbsoluteUrl(`/media/svg/${prefix}/${path}`)}
        style={{ pointerEvents: "none" }}
        cacheRequests
      >
        {children}
      </SVG>
    </span>
  );
};
AESVG.propTypes = {
  // icon: PropTypes.oneOf(["General/Search.svg"]),//todo
  path: PropTypes.string,
  variant: PropTypes.string,
};
